import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
// import { logoutUser } from "../slices";
const pythonBackendUrl = process.env.REACT_APP_PYTHON_BE;

export const datalyzeModelBuildingApis = createApi({
    reducerPath: "modelBuildingApis",
    baseQuery: fetchBaseQuery({
        baseUrl: pythonBackendUrl,
    }),
    refetchOnFocus: true,
    endpoints: (builder) => ({
        getSchema: builder.query({
            query: (payload) => ({
                url: `/api/modeling/schema?dataset_id=${payload?.datasetId}`,
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            }),
        }),
        getModels: builder.mutation({
            query: (payload) => ({
                url: `/api/modeling/train`,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: payload
            }),
        }),

        getPrediction: builder.mutation({
            query: (payload) => ({
                url: `/api/modeling/predict`,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: payload
            }),
        }),
        finetuneModel: builder.mutation({
            query: (payload) => ({
                url: `/api/modeling/fine-tune`,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: payload
            }),
        }),
        predictTunedModel: builder.mutation({
            query: (data) => ({
                url: '/api/modeling/predict-tuned',
                method: 'POST',
                body: data
            })
        }),
    }),
});

export const {
    useGetSchemaQuery,
    useGetModelsMutation,
    useGetPredictionMutation,
    useFinetuneModelMutation,
    usePredictTunedModelMutation
} = datalyzeModelBuildingApis;